import { useMutation, useQueryClient } from "@tanstack/react-query";
import { setMonitorErrorStatus } from "@/api/monitor";
import { MonitorQueryKeys } from "@/tanstackQuery/queries/monitor";
import { MonitorErrorStatus } from "@/types/ApiResponses/Monitor";

export const useSetMonitorErrorStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      fingerprint,
      status,
    }: {
      fingerprint: string;
      status: MonitorErrorStatus;
    }) => setMonitorErrorStatus({ fingerprint, status }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MonitorQueryKeys.ErrorsPaginated],
      });
      queryClient.invalidateQueries({
        queryKey: [MonitorQueryKeys.ErrorDetail],
      });
    },
  });
};
